/** True when a post-login redirect stays on this origin (blocks `//evil` / `\\evil`). */
export function isSafeInternalPath(path: string | null | undefined): path is string {
  if (!path) return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//') || path.startsWith('/\\')) return false;
  if (path.includes('\\') || path.includes('://')) return false;
  return true;
}
